// ================================================================
//  captureUploadBar
//  Progress-bar style comparison (track = Captured, fill = Uploaded)
//  rather than two independent bars on a shared axis — `uploaded` is
//  a SUBSET of `captured` (every uploaded frame was necessarily
//  captured first), so this is fundamentally a "what % of the whole
//  is this part" relationship, not two comparable-magnitude values.
//  A two-bar chart makes the smaller value visually vanish whenever
//  the split is lopsided (e.g. 5% uploaded) — a fixed-width track
//  with a proportional fill (same convention as this dialog's own
//  Average Pressure bar) stays legible at any ratio, with the exact
//  percentage always spelled out in text regardless of how thin the
//  fill renders. Used right alongside packetDistributionPie — see
//  environment-status-dialog.html and consolidated-stats-dialog.html.
//
//  Bindings (one-way, plain numbers — pass 0/undefined for "no data
//  yet", never pre-round or format):
//    - captured : total_frames_captured
//    - uploaded : total_frames_uploaded
// ================================================================

angular.module('bizmetryApp').component('captureUploadBar', {
  bindings: {
    captured: '<',
    uploaded: '<'
  },
  template: `
    <div class="cub-container">
      <div class="cub-empty" ng-if="$ctrl.isEmpty()">
        <md-icon>bar_chart</md-icon>
        <span>No traffic captured yet</span>
      </div>
      <div class="cub-body" ng-if="!$ctrl.isEmpty()">
        <div class="cub-row">
          <span class="cub-label">Captured</span>
          <span class="cub-value">{{ ($ctrl.captured || 0).toLocaleString() }}</span>
        </div>
        <div class="cub-track">
          <div class="cub-fill" ng-style="{ width: $ctrl.uploadedPercent() + '%' }"></div>
        </div>
        <div class="cub-row cub-row--sub">
          <span class="cub-label"><span class="cub-dot"></span>Uploaded</span>
          <span class="cub-value">{{ ($ctrl.uploaded || 0).toLocaleString() }} ({{ $ctrl.uploadedPercent() }}%)</span>
        </div>
      </div>
    </div>
  `,
  controller: function () {
    var ctrl = this;

    ctrl.isEmpty = function () {
      return !ctrl.captured && !ctrl.uploaded;
    };

    // Clamped to [0, 100] — uploaded can't exceed captured by definition,
    // but a stale/racy read across two separately-fetched counters
    // shouldn't be allowed to render a fill wider than its own track.
    ctrl.uploadedPercent = function () {
      var captured = ctrl.captured || 0;
      var uploaded = ctrl.uploaded || 0;
      if (!captured) { return 0; }
      var pct = Math.round((uploaded / captured) * 1000) / 10;
      return Math.max(0, Math.min(100, pct));
    };
  }
});
